// extracted by mini-css-extract-plugin
module.exports = {"container":"ExpandTrigger_container__1fOtw","expanded":"ExpandTrigger_expanded__1HxfU"};